import { PendingAddress } from '../common';

/* eslint-disable @typescript-eslint/naming-convention */
export interface AvailableEmployeeResult {
  EmployeeID: string;
  HRRef: number | null;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Designation: string;
  VPCompanyID: number | null;
  Active: boolean;
  ChangesApproved: boolean | null;
  PendingAddress: PendingAddress;
  AbsorbDateUpdated: Date | null;
}
